import { ShippingAddressBookType } from '@/services/mallUser.service';
import { create, createStore } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export const defaultState: OrderNPayStoreState = {
    ['']: {
        productList: [],
        addonProductList: [],
        setProductList: [],
        isSetProduct: false,
    },
};

export const useOrderNPayStore = create<OrderNPayStoreAction>()(
    persist(
        (set, get) => ({
            ...defaultState,
            setOrderData: (key, data) => {
                set((state) => {
                    return {
                        [key]: {
                            setProductList: data?.setProductList || state[key]?.setProductList,
                            productList: data?.productList || state[key]?.productList,
                            addonProductList: data?.addonProductList || state[key]?.addonProductList,
                            isSetProduct: data?.isSetProduct || state[key]?.isSetProduct,
                        },
                    };
                });
            },
            update: (data) =>
                set(
                    {
                        ...data,
                        setOrderData: get().setOrderData,
                        reset: get().reset,
                        update: get().update,
                    },
                    true,
                ),
            reset: () =>
                set(
                    {
                        ...defaultState,
                        setOrderData: get().setOrderData,
                        reset: get().reset,
                        update: get().update,
                    },
                    true,
                ),
        }),
        {
            name: 'orderNPay-storage',
            storage: createJSONStorage(() => localStorage),
        },
    ),
);
export interface OrderNPayStoreState {
    ['']: {
        productList?: {
            productGroupId: string;
            productId?: string;
            productIds?: string[];
            productCharge: number;
            productPrice: number;
            inventory: number;
            numberOfPicked: number;
            optionName: string;
            representProductId: string;
            representProductImage: string;
            representProductName: string;
            representProductPrice: number;
            totalCharge: number;
            isForSale: boolean;
            discountMethod: 'won' | 'percent';
            discountValue: number;
            ownerType: 'SELLER' | 'VENDOR';
            productShippingPolicy: {
                freeShippingCostBar: number;
                islandMountainDiscountShippingCostBar: number;
                islandMountainDiscountedPrice: number;
                islandMountainShippingCost: number;
                shippingCost: number;
                jejuShippingCost: number;
                jejuDiscountShippingCostBar: number;
                jejuDiscountedPrice: number;
            };
        }[];
        setProductList: {
            productGroupId: string;
            productId?: string;
            productIds?: string[];
            productCharge: number;
            productPrice: number;
            inventory: number;
            numberOfPicked: number;
            optionName: string;
            representProductId: string;
            representProductImage: string;
            representProductName: string;
            representProductPrice: number;
            totalCharge: number;
            isForSale: boolean;
            discountMethod: 'won' | 'percent';
            discountValue: number;
            ownerType: 'SELLER' | 'VENDOR';
            productShippingPolicy: {
                freeShippingCostBar: number;
                islandMountainDiscountShippingCostBar: number;
                islandMountainDiscountedPrice: number;
                islandMountainShippingCost: number;
                shippingCost: number;
                jejuShippingCost: number;
                jejuDiscountShippingCostBar: number;
                jejuDiscountedPrice: number;
            };
        }[];
        addonProductList: {
            productGroupId: string;
            productId: string;
            numberOfPicked: number;
            optionName: string;
            optionValue: string;
            totalCharge: number;
        }[];
        isSetProduct: boolean;
    };
}
type OrderNPayStoreAction = OrderNPayStoreState & {
    setOrderData: (key: string, data: OrderNPayStoreState['']) => void;
    reset: () => void;
    update: (data: OrderNPayStoreState) => void;
};
